import { getCoach, type WithId } from '@/libs/firebase/firestore/firestore-helpers';
import { Address } from '@/types';

export type CoachDoc = {
  id?: string | null;
  name?: string;
  active_session_id?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  academy_id?: string | null;
  phone?: string | null;
  address?: Address;
  updated_at?: string | null;
  email?: string | null;
  inactiveFilterLevel?: string | number | null;
};

export async function fetchCoachByUid(uid: string): Promise<WithId<CoachDoc> | null> {
  return await getCoach<CoachDoc>(uid);
}
